import { render, staticRenderFns } from "./DossiersEnAlerte.vue?vue&type=template&id=d99f9ab0&scoped=true&"
import script from "./DossiersEnAlerte.vue?vue&type=script&lang=js&"
export * from "./DossiersEnAlerte.vue?vue&type=script&lang=js&"
import style0 from "./DossiersEnAlerte.vue?vue&type=style&index=0&id=d99f9ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99f9ab0",
  null
  
)

export default component.exports